import React from "react"
import BannerContainer from "@components/BannerContainer"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import ContactImage from "./Contact.png"
import ContactMobileImage from "./contact-mobile.png"
import gridBreakpoints from "@styles/bs-modifiers/grid-breakpoints.js"
import styles from "./BannerContactUs.module.scss"
import classnames from "classnames/bind"

const BannerContactUs = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <div
              className={
                styles.contentWrapper + " pr-lg-10 text-center text-lg-left"
              }
            >
              <h1
                className={classnames(
                  styles.title,
                  "proxima-nova--extra-bold",
                  "fs-30pt",
                  "text-white",
                  "mb-5",
                  "fs-lg-40pt",
                  "fs-xl-58pt"
                )}
              >
                <TopTitle
                content="SIMPLE, SECURE AND FLEXIBLE"
                className={styles.topTitle}
                removeBottomSpace={true}
                /> LET'S TALK!
              </h1>
              <p
                className={
                  styles.description +
                  " fs-18pt fs-xl-23pt text-white proxima-nova--light"
                }
              >
                We love all feedback, our team is ready to help.
              </p>
              <AnchorButton
                href="/demo"
                content="SEE A DEMO"
                className={styles.button}
              />
            </div>

            <div className={styles.emptyBlockLeft + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
      rightClassName="align-items-center align-items-lg-end"
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <WrapperInner className={styles.wrapperInnerRight + " pl-lg-10"}>
              <picture>
                <source
                  media={`(min-width: ${gridBreakpoints.lg}px)`}
                  srcSet={ContactImage}
                  className={styles.contactImage + " w-100 ml-auto"}
                />
                <source
                  media={`(min-width: ${gridBreakpoints.xs}px)`}
                  srcSet={ContactMobileImage}
                  className={styles.contactImage + " w-100 ml-auto"}
                />
                <img
                  src={ContactImage}
                  alt="Contact Us"
                  className={styles.contactImage + " w-100 ml-auto"}
                />
              </picture>
            </WrapperInner>
            <div className={styles.emptyBlockRight + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerContactUs
